var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"font-weight-medium",attrs:{"small":"","color":_vm.config.color,"text-color":_vm.config.textColor}},[_vm._v(" "+_vm._s(_vm.config.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }